import React, { useEffect, useState } from 'react';
import Buttons from '../Constans/Buttons';
import SelectProcess from './DeviceSelectionSteps/SelectProcess';
import PhoneOptions from './DeviceSelectionSteps/PhoneOptions';
import { GetProductsList, GetProductDetails, setSelectedPhone, GetCustomerExposure, setCreditDecision } from '../IdfSaleSlice';
import { useDispatch, useSelector } from 'react-redux';
import { PathHistory } from '../IdfSaleEnums';
import { isNullOrEmpty } from 'app/utilities/StringHelpers/StringHelpers';
import ErrorPage from '../PopUps/ErrorPage';
import { ErrorCode } from '../IdfSaleEnums';


import { dwhReport, dwhDictionary } from '../dwhReports/dwhGeneralReport';
export default function DeviceSelection(props) {
  const dispatch = useDispatch();
  const store = props.idfStore;
  var selectedPhone = !isNullOrEmpty(store.selectedPhone) ? store.selectedPhone : null;
  const { processType } = store;
  const { setProcessType, setSelectedPhone, setFeatureList } = props;
  const [deviceSelectionStep, setDeviceSelectionStep] = useState(props.setInnerStep ? 2 : 1);
  const [data, setData] = useState(null);
  const isShowEsim = props.contentData.eSimFlag.value;
  const [errorCode, setErrorCode] = useState(null);

  async function handlePhoneClick() {
    const res = await dispatch(GetProductDetails({ modelId: selectedPhone?.modelId, isLeasing: store.isLeasing }));
    if (res)
      setFeatureList(res.payload)
  }
  useEffect(() => {
    if (!isNullOrEmpty(selectedPhone?.modelId) && deviceSelectionStep == 1) {
      handlePhoneClick();
    }
  }, [selectedPhone?.modelId]);

  useEffect(() => {
    props.setDeliveryMode('')
  }, []);


  useEffect(() => {
    if (store.steps.current == PathHistory.DeviceSelectionStep2) {
      setDeviceSelectionStep(2);
    } else {
      setDeviceSelectionStep(1);
      //props.setSelectedPhone(null);
      setProductList();
    }

  }, [store.steps]);

  const setProductList = async () => {
    const res = await dispatch(GetProductsList());
    if (res) {
      setData(res.payload)
    };
  };


  const onClickNavigation = async (obj = null) => {
    window.scrollTo({
      top: 0,
      behavior: 'instant', // You can use 'auto' for instant scrolling
    });
    var isEndProcess = false;
    if (deviceSelectionStep == 1) {
      if (processType === 'SIM') {
        props.setSelectedPhone(null);
        props.setFeatureList(null);
        isEndProcess = true;
      } else {
        if (selectedPhone !== null) {
          setDeviceSelectionStep(2);
        }
      }
      dwhReport({ ...dwhDictionary.ProcessSelection_Ongoing })
    } else {
      isEndProcess = true;
    }
    if (isEndProcess) {
      const productsList = [];

      if (!(store.lineType == 2 && store.processType == 'SIM')) {

        if (store.lineType != 2 && !store.deviceUpgradeProcessing) {
          productsList.push({
            productType: 'CELLULAR',
            productCount: 1,
            productAmount: 0,
          });
        }

        if (store.processType !== 'SIM' && obj != null) {
          productsList.push({
            productType: 'PHONE',
            productCount: 1,
            productAmount: Math.floor(obj.price),
          });
        }
        const req = {
          productsList,
          paymentType: 1,
        };
        const res = await dispatch(GetCustomerExposure(req));
        if (res.payload?.returnCode !== "00") {
          setErrorCode(667);
          return false;
        } else {
          dispatch(setCreditDecision({ decisionSeq: res.payload.decisionSeq, nonSeparDepos: res.payload.nonSeparDepos }))
        }
      }
    }

    return true;
  };

  return (<>
    {errorCode != null ?
      <ErrorPage errorCode={errorCode} />
      :
      <div className='idf-device-selection step fixed-footer'>
        {deviceSelectionStep == 1 && (
          <SelectProcess
            {...props}
            data={data}
            isShowEsim={isShowEsim}
            processType={processType}
            setProcessType={setProcessType}
            setDeviceSelectionStep={setDeviceSelectionStep}
            onClickNavigation={onClickNavigation}></SelectProcess>
        )}
        {deviceSelectionStep == 2 && (
          <PhoneOptions
            {...props}
            onClickNavigation={onClickNavigation}
            //selectedPhone={selectedPhone}
            // selectedPhoneList={{ ...selectedPhoneList, bpkey: selectedPhone.bpkey }}
            setDeviceSelectionStep={setDeviceSelectionStep}></PhoneOptions>
        )}

      </div>
    }</>
  );
}
